import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { billingEntitiesTypes } from 'actions/types'

const initialState = []
const baseType = billingEntitiesTypes.FETCH_BILLING_ENTITIES

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
